export function encodeImageName(name) {
  return name ? name.replace(/\//g, "-").replace(/ /g, "+") : name;
}
